import { Box, Flex } from '@osmosis/tailwind-ui/components/Box';
import { Input, InputProps } from '@osmosis/tailwind-ui/components/Input';
import React, { ReactNode } from 'react';

export type InputWithIconProps = InputProps & {
  icon?: ReactNode;
};

/**
 * .
 */
const InputWithIcon = (props: InputWithIconProps) => {
  const { icon, ...inputProps } = props;
  return (
    <Box className="relative w-full">
      {icon && (
        <Flex className="absolute left-0 top-0 h-full items-center justify-center p-2 px-[.75em]">
          {icon}
        </Flex>
      )}
      <Input
        data-testid="input-with-icon"
        {...inputProps}
        className={`pl-8 ${inputProps.className || ''}`}
      />
    </Box>
  );
};

export default InputWithIcon;
